import { AtsStaticTooltipParentRefEnum } from '@alliance/shared/utils'
import { Directive, HostListener, Input } from '@angular/core'
import { RxStateComponent } from '@alliance/shared/models'
import { StaticTooltipViewHelperService } from './services/static-tooltip-view-helper.service'

@Directive({
  selector: '[allianceApplyStaticTooltipAction]'
})
export class ApplyStaticTooltipActionDirective extends RxStateComponent<{ isApplied: boolean }> {
  @Input() public parentRef: AtsStaticTooltipParentRefEnum | undefined

  public constructor(private staticTooltipViewHelperService: StaticTooltipViewHelperService) {
    super()
    this.initState({
      isApplied: false
    })
  }

  @HostListener('click')
  public applyAction(): void {
    if (!this.get().isApplied && this.parentRef) {
      this.set({ isApplied: true })
      this.staticTooltipViewHelperService.clearActiveParentState()
      this.staticTooltipViewHelperService.preventShowingTooltipByParentKey(this.parentRef)
    }
  }
}
